/* Package JSON Import will be here */
import { filter, includes, findIndex, indexOf, sortBy, forEach } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { ISelectedAttrFilter, IGetAttrFilterParams } from "models/filterModels";
import Constants from "utilities/appConstants";
import { appRoutesConst } from "app/navigation";
import { getAttrFilterListApi } from "services/filter";
/* Project Import will be here */

export const types = {
    INIT_SORTING: "attrFilter/INIT_SORTING",
    ATTR_FILTER_REQUEST: "attrFilter/attrFilterRequest",
    ATTR_FILTER_SUCCESS: "attrFilter/attrFilterSuccess",
    ATTR_FILTER_FAILURE: "attrFilter/attrFilterFailure",
    ON_CHANGE_ATTR_FILTER: "attrFilter/onChangeAttrFilter",
    CLEAR_ATTR_FILTER: "attrFilter/clearAttrFilter",
    UPDATE_SELECTED_SORTING_FILTER: "attrFilter/updateSelectedSortingFilter",
    UPDATE_SELECTED_SORTING_FILTER_TEMP: "attrFilter/UPDATE_SELECTED_SORTING_FILTER_TEMP",
    UPDATE_ATTR_FILTER_APPLIED: "attrFilter/updateAttrFilterApplied"
};

let initialState = {
    isLoading: false,
    data: [],
    selectedAttrFilter: [],
    selectedSortingFilter: null,
    selectedSortingFilterTemp: null,
    isAttrFilterApplied: false,
    error: null
};

export const attrFilter = (state = initialState, action) => {
    switch (action.type) {
        case types.INIT_SORTING: {
            return {
                ...state,
                filter: {
                    ...state.filter,
                    Sorting: action.payload
                }
            };
        }
        case types.ATTR_FILTER_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.ATTR_FILTER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false
            };
        case types.ATTR_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.ON_CHANGE_ATTR_FILTER:
            return {
                ...state,
                ...action.payload,
            };
        case types.UPDATE_SELECTED_SORTING_FILTER:
            return {
                ...state,
                ...action.payload,
            };
        case types.UPDATE_ATTR_FILTER_APPLIED:
            return {
                ...state,
                ...action.payload,
            };
        case types.UPDATE_SELECTED_SORTING_FILTER_TEMP:
            return {
                ...state,
                ...action.payload,
            };
        case types.CLEAR_ATTR_FILTER:
            return {
                ...state,
                selectedAttrFilter: [],
                selectedSortingFilter: action.payload.sorting,
                selectedSortingFilterTemp: action.payload.sorting,
                isAttrFilterApplied: action.payload.isFilterApplied,
            };
        default:
            return state;
    }
};

export const initializeSortingFilter = (defaultSorting) => ({
    type: types.INIT_SORTING,
    payload: defaultSorting
});

/* Get product attribute filter and value list */
export const getAttrFilterList = (requestObj: IGetAttrFilterParams) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.ATTR_FILTER_REQUEST });
        try {
            const response = await getAttrFilterListApi(requestObj);

            /* Sort attributes based on Sequence property */
            const sortedList = sortBy(response.data.Data, (o) => {
                return o.Sequence;
            });

            dispatch({
                type: types.ATTR_FILTER_SUCCESS,
                payload: { data: sortedList }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.ATTR_FILTER_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* Handle select or un-select attr value items */
export const onChangeFilterData = (attrId, attrValueId, selectionType) => {
    return async (dispatch, getState) => {
        const attrFilter = getState().attrFilter;
        let tempArray = attrFilter.selectedAttrFilter;

        /* Check if the attr is already selected */
        const selectedAttrData = filter(attrFilter.selectedAttrFilter, (o) => {
            return o.AttrId === attrId;
        })[0];

        if (attrFilter.selectedAttrFilter.length > 0 && selectedAttrData !== undefined) {
            const attrIndex = findIndex(tempArray, (o) => {
                return o.AttrId === attrId;
            });

            /* Check for selection type multiple */
            if (selectionType === Constants.MULTIPLE) {
                if (includes(selectedAttrData.AttrValues, attrValueId)) {
                    if (selectedAttrData.AttrValues.length === 1) {
                        tempArray.splice(attrIndex, 1);
                    }
                    else {
                        const attrValueIndex = indexOf(tempArray[attrIndex].AttrValues, attrValueId);
                        tempArray[attrIndex].AttrValues.splice(attrValueIndex, 1);
                    }
                }
                else {
                    tempArray[attrIndex].AttrValues.push(attrValueId);
                }
            }
            /* Check for selection type single */
            else if (selectionType === Constants.SINGLE) {
                tempArray[attrIndex].AttrValues[0] = attrValueId;
            }
            /* Check for selection type range */
            else if (selectionType === Constants.RANGE) {
                tempArray[attrIndex].AttrRangeValues = attrValueId;
            }

            /* Remove sorting on any change in attr value */
            tempArray[attrIndex].Sorting = "";
        }
        else {
            const attrData: ISelectedAttrFilter = { AttrId: attrId, Sorting: "" };

            if (selectionType === Constants.RANGE) {
                attrData.AttrRangeValues = attrValueId;
                attrData.AttrValues = []
            }
            else {
                attrData.AttrRangeValues = [0, 0];
                attrData.AttrValues = [attrValueId]
            }

            tempArray.push(attrData)
        }

        dispatch({
            type: types.ON_CHANGE_ATTR_FILTER,
            payload: {
                selectedAttrFilter: tempArray
            }
        });
    }
}

/* Handle select or un-select sorting attribute */
export const onChangeAttrSortData = (attrId, sortType) => {
    return async (dispatch, getState) => {
        /* Splice the selected sorting attribute */
        const attrFilter = getState().attrFilter;
        let tempArray = attrFilter.selectedAttrFilter;

        /* Remove sorting from unselected attributes */
        let itemsToBeSplice = [];

        forEach(tempArray, (o, index) => {
            if ((o.AttrId === attrId) || (tempArray[index].AttrValues.length === 0 && tempArray[index].AttrRangeValues[0] === 0 && tempArray[index].AttrRangeValues[1] === 0))
                itemsToBeSplice.push(o.AttrId);
            else
                tempArray[index].Sorting = "";
        });

        forEach(itemsToBeSplice, (p) => {
            const attrIndex = findIndex(tempArray, (o) => { return o.AttrId === p });
            tempArray.splice(attrIndex, 1);
        });
        /* Remove sorting from unselected attributes */

        /* Add sorting for selected attribute */
        const selectedAttrData = filter(attrFilter.selectedAttrFilter, (o) => { return o.AttrId === attrId; })[0];

        if (attrFilter.selectedAttrFilter.length > 0 && selectedAttrData !== undefined) {
            const attrIndex = findIndex(tempArray, (o) => { return o.AttrId === attrId; });
            tempArray[attrIndex].AttrValues = [];
            tempArray[attrIndex].AttrRangeValues = [0, 0];
            tempArray[attrIndex].Sorting = sortType;
        }
        else {
            const attrData: ISelectedAttrFilter = {
                AttrId: attrId,
                AttrRangeValues: [0, 0],
                AttrValues: [],
                Sorting: sortType
            };

            tempArray.push(attrData)
        }
        /* Add sorting for selected attribute */

        dispatch({
            type: types.ON_CHANGE_ATTR_FILTER,
            payload: {
                selectedAttrFilter: tempArray
            }
        });
    }
}

/* Clear attr filter */
export const clearAttrFilter = (retainSortingFilter = false) => {
    return async (dispatch, getState) => {
        let payloadData = {};

        let path = window.location.pathname;
        let isFromSalesReturn = path === appRoutesConst.salesReturn || path.includes(Constants.PATH_INCLUDE_SALES_RETURN_PRODUCTS) ? Constants.NAME_ASC : getState().appSettings.defaultProductSorting
        if (retainSortingFilter) {
            payloadData = {
                sorting: getState().attrFilter.selectedSortingFilter,
                isFilterApplied: getState().attrFilter.isAttrFilterApplied ? true : false
            }
        }
        else {
            payloadData = {
                sorting: isFromSalesReturn,
                isFilterApplied: false
            }
        }

        dispatch({ type: types.CLEAR_ATTR_FILTER, payload: payloadData });
    }
}

export const updateSelectedSortingFilterTemp = (filter) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.UPDATE_SELECTED_SORTING_FILTER_TEMP,
            payload: {
                selectedSortingFilterTemp: filter
            }
        });
    }
};

/* Update selected sorting filter */
export const updateSelectedSortingFilter = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.UPDATE_SELECTED_SORTING_FILTER,
            payload: {
                selectedSortingFilter: getState().attrFilter.selectedSortingFilterTemp
            }
        });
    }
}

/* Update isFilterAppliedParam */
export const updateFilterApplied = (isFilterApplied) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.UPDATE_ATTR_FILTER_APPLIED,
            payload: {
                isAttrFilterApplied: isFilterApplied
            }
        });
    }
}